import { Link } from "react-router-dom";

export const TermsOfService = () => {
  return (
    <main className="pt-20">
      {/* Hero Banner */}
      <div className="bg-brand-navy py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
          <span className="inline-block text-xs sm:text-sm font-medium uppercase tracking-widest text-brand-orange mb-2">
            Legal
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight uppercase text-white">
            Terms of Service
          </h1>
          <p className="font-body text-base sm:text-lg text-white/70 mt-3 max-w-2xl">
            Last updated: February 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-12">
          <div className="prose prose-lg max-w-none">
            
            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Agreement to Terms
            </h2>
            <p className="text-brand-slate mb-6">
              By accessing or using the Roll Orlando website (rollorlando.com) and our painting services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services. Roll Orlando provides professional painting services in Orlando, Florida and surrounding Central Florida areas.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Services Description
            </h2>
            <p className="text-brand-slate mb-4">Roll Orlando provides the following professional painting services:</p>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li><strong>Interior Painting:</strong> Wall and ceiling painting, trim and baseboard painting, cabinet refinishing, and color consultation</li>
              <li><strong>Exterior Painting:</strong> House exterior painting, stucco painting, pressure washing, and weather-resistant finishes</li>
              <li><strong>Popcorn Ceiling Removal:</strong> Texture removal, smooth finish application, ceiling repairs, and painting after removal</li>
              <li><strong>Garage Floor Coatings:</strong> Epoxy coatings, polyaspartic finishes, decorative flakes, and anti-slip textures</li>
              <li><strong>Deck Painting & Staining:</strong> Deck staining, deck painting, wood restoration, and sealant application</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Service Area
            </h2>
            <p className="text-brand-slate mb-6">
              We proudly serve Orlando, Florida and the greater Central Florida area, including but not limited to: Winter Park, Kissimmee, Lake Nona, Dr. Phillips, Windermere, Altamonte Springs, Oviedo, Sanford, and surrounding communities in Orange, Seminole, and Osceola counties.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Estimates and Pricing
            </h2>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li>All estimates are provided free of charge with no obligation</li>
              <li>Estimates are valid for 30 days from the date issued</li>
              <li>Final pricing may vary based on actual job conditions discovered during work</li>
              <li>Any changes to the scope of work must be agreed upon in writing</li>
              <li>We reserve the right to adjust pricing for significant changes in material costs</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Payment Terms
            </h2>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li>A deposit may be required to schedule work, as specified in your project agreement</li>
              <li>Final payment is due upon completion and your satisfaction with the work</li>
              <li>We accept cash, check, and major credit cards</li>
              <li>Late payments may be subject to additional fees</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Warranty
            </h2>
            <p className="text-brand-slate mb-6">
              Roll Orlando stands behind our work with a written warranty. The specific warranty terms will be provided in your project agreement. Our warranty covers defects in workmanship but does not cover damage caused by normal wear and tear, accidents, or improper maintenance.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Customer Responsibilities
            </h2>
            <p className="text-brand-slate mb-4">As our customer, you agree to:</p>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li>Provide accurate information about your property and project requirements</li>
              <li>Ensure safe and reasonable access to work areas</li>
              <li>Remove or protect personal belongings near work areas</li>
              <li>Notify us of any known hazards, such as lead paint or asbestos</li>
              <li>Obtain any necessary HOA approvals or permits (we can assist with this)</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Cancellation Policy
            </h2>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li>Cancellations made more than 48 hours before scheduled work: Full refund of any deposit</li>
              <li>Cancellations made within 48 hours: Deposit may be forfeited or applied to rescheduled work</li>
              <li>We reserve the right to cancel or reschedule due to weather conditions or unforeseen circumstances</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Licensing and Insurance
            </h2>
            <p className="text-brand-slate mb-6">
              Roll Orlando is a fully licensed and insured painting contractor in the State of Florida. We maintain comprehensive general liability insurance and workers' compensation coverage to protect our customers and employees. Proof of insurance is available upon request.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Website Use
            </h2>
            <p className="text-brand-slate mb-4">When using our website, you agree not to:</p>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li>Use the website for any unlawful purpose</li>
              <li>Submit false or misleading information</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper functioning of the website</li>
              <li>Copy, modify, or distribute our content without permission</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Limitation of Liability
            </h2>
            <p className="text-brand-slate mb-6">
              To the maximum extent permitted by law, Roll Orlando shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or services. Our total liability shall not exceed the amount paid by you for the specific service giving rise to the claim.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Dispute Resolution
            </h2>
            <p className="text-brand-slate mb-6">
              Any disputes arising from these terms or our services shall be resolved through good-faith negotiation. If a resolution cannot be reached, disputes shall be subject to the laws of the State of Florida, with venue in Orange County, Florida.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Changes to Terms
            </h2>
            <p className="text-brand-slate mb-6">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after any changes constitutes acceptance of the new terms.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Contact Information
            </h2>
            <p className="text-brand-slate mb-4">
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-brand-ice p-6 rounded-sm border border-border mb-8">
              <p className="text-brand-navy font-semibold mb-2">Roll Orlando</p>
              <p className="text-brand-slate">Orlando, Florida</p>
              <p className="text-brand-slate">Phone: <a href="tel:+14079494656" className="text-brand-orange hover:underline">(407) 949-4656</a></p>
              <p className="text-brand-slate">Email: <a href="mailto:sales@rollorlando.com" className="text-brand-orange hover:underline">sales@rollorlando.com</a></p>
              <p className="text-brand-slate">Website: <a href="https://rollorlando.com" className="text-brand-orange hover:underline">rollorlando.com</a></p>
            </div>

            <div className="mt-8 pt-8 border-t border-border">
              <Link 
                to="/" 
                className="text-brand-orange hover:text-brand-navy font-medium transition-colors"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
